<!-- eslint-disable vue/no-v-html -->
<template>
  <QDialog
    v-model="displayDialog"
    :class="newDesign && 'new-design'"
    persistent
  >
    <QCard
      class="remove-element-confirm-modal"
      :class="newDesign ? 'q-pa-md new-design' : ''"
    >
      <QCardSection class="row items-center">
        <span
          :class="newDesign ? 'text-center' : 'top-bar bold'"
          v-html="titleText"
        />
      </QCardSection>
      <QCardActions align="right">
        <QBtn
          :aria-label="cancelBtnText"
          flat
          :label="cancelBtnText"
          @click="cancelClicked"
        />
        <QBtn
          :aria-label="confirmBtnText"
          class="confirm cursor-pointer"
          flat
          :label="confirmBtnText"
          @click="confirmClicked"
        />
      </QCardActions>
    </QCard>
  </QDialog>
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";
import useModal from "shared/composables/useModal";

export default {
  name: "RemoveElementConfirmModal",
  props: {
    titleText: {
      type: String,
      required: true,
    },
    confirmBtnText: {
      type: String,
      default: () => getLocaleText("global.confirm"),
    },
    cancelBtnText: {
      type: String,
      default: () => getLocaleText("global.cancel"),
    },
    newDesign: {
      type: Boolean,
    },
  },
  emits: ["confirm", "cancel"],
  setup() {
    const { close } = useModal("ConfirmModal");

    return { close };
  },
  data() {
    return {
      displayDialog: true,
    };
  },
  methods: {
    confirmClicked() {
      this.$emit("confirm");
      this.close();
    },
    cancelClicked() {
      this.$emit("cancel");
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.remove-element-confirm-modal {
  background-color: $white;

  .q-btn {
    flex: 1;
    background-color: $silver-white;
    box-shadow: none;

    &.confirm {
      background-color: $active;
      color: $silver-white;
    }
  }

  .top-bar {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid $silver-white;
    font-size: 18px;
  }
}

.new-design {
  border-radius: 10px;

  .q-btn {
    flex: 1;
    background-color: $hover-background;
    box-shadow: 0 2px 0 rgba($black, 0.043);
    border-radius: 4px;

    &.confirm {
      color: $white;
      background-color: $ds-red-5;
    }
  }
}
</style>
